const JCS_WIDGET_DOMAIN_PROD = 'https://jcs-chat-widget.atlassian.com';
const JCS_WIDGET_DOMAIN_STG = 'https://jcs-chat-widget.stg.atlassian.com';

export const getPreconnectHref = (
	site: string,
): 'https://jcs-chat-widget.atlassian.com' | 'https://jcs-chat-widget.stg.atlassian.com' => {
	return /jira-dev\.com/.test(site) ? JCS_WIDGET_DOMAIN_STG : JCS_WIDGET_DOMAIN_PROD;
};
